import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import FilterMenu from '../FilterMenu';
import { FilterMenusProps } from '../FilterMenus';
import CheckList from '../Filters/CheckList/CheckList';
import { Filter } from '../../../../types/main';
import { selectLists } from '../../../../store/modules/lists/selectors';
import FilterSelect from '../Filters/FilterSelect/FilterSelect';
import { getAssignedToList, updatedRecordList, getBillingToList } from '../constants';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';

const ProjectFilterMenu = (props: FilterMenusProps) => {
  const filterKeys = useMemo(() => ['status', 'updated', 'assigned_to', 'is_billing_completed'], []);
  const { data: lists } = useSelector(selectLists);
  const { data: user } = useSelector(selectCurrentUser);

  const statusesList = lists
    ? lists['project-status']
      .map((item) => ({ key: item.key.toString(), value: item.value, label: item.value }))
      .filter((item) => !['0', '-1'].includes(item.key))
    : [];

  const filterLabels = useMemo(() => {
    return [
      ...updatedRecordList.map((option): Filter => ({
        key: 'updated',
        value: option.label,
        label: option.label,
      })),
      ...statusesList.map((option) => ({
        key: 'status',
        value: option.key,
        label: option.value,
      })),
      ...getAssignedToList(user).map((option) => ({
        key: 'assigned_to',
        value: option.key,
        label: option.label,
      })),
      ...getBillingToList.map((option): Filter => ({
        key: 'is_billing_completed',
        value: option.key,
        label: option.label,
      })),
    ];
  }, [statusesList, user]);

  const leftContent = useCallback((filters: Filter[], setFilters: (filters: Filter[]) => void) => (
    <CheckList
      title="Status"
      filterName="status"
      list={statusesList}
      filtersState={filters}
      updateFiltersState={setFilters}
    />
  ), [statusesList]);

  const rightContent = useCallback((filters: Filter[], setFilters: (filters: Filter[]) => void) => (
    <>
      <FilterSelect
        name="updated"
        label="Updated"
        filtersState={filters}
        updateFiltersState={setFilters}
        options={updatedRecordList}
      />
      <FilterSelect
        name="assigned_to"
        label="Assigned To"
        filtersState={filters}
        updateFiltersState={setFilters}
        options={getAssignedToList(user)}
      />
      <FilterSelect
        name="is_billing_completed"
        label="Billing Completed"
        filtersState={filters}
        updateFiltersState={setFilters}
        options={getBillingToList}
      />
    </>
  ), [user]);

  return (
    <FilterMenu
      menuFilterKeys={filterKeys}
      leftContent={leftContent}
      rightContent={rightContent}
      filterLabels={filterLabels}
      {...props}
    />
  );
};

export default ProjectFilterMenu;
